import React from 'react';

const ProjectItemSummaryCard = ({ projectItem, t }) => {
  if (!projectItem) {
    return null;
  }

  return (
    <div className="production-kanban-card production-kanban-task-card">
      <div className="production-kanban-task-card-header">
        <div className="production-kanban-task-card-title-block">
          <div className="production-kanban-task-card-title">
            {t ? t('fieldProjectItem') : 'Projekt tétel'}
          </div>
        </div>
      </div>

      <div className="production-kanban-task-card-footer">
        <div className="production-kanban-task-card-meta-item">
          <span className="production-kanban-task-card-meta-label">
            {t ? t('fieldName') : 'Megnevezés'}
          </span>
          <strong>{projectItem.name || '-'}</strong>
        </div>

        <div className="production-kanban-task-card-meta-item">
          <span className="production-kanban-task-card-meta-label">
            {t ? t('quantity') : 'Mennyiség'}
          </span>
          <strong>
            {projectItem.quantity || 0} {projectItem.unit?.name || ''}
          </strong>
        </div>
      </div>
    </div>
  );
};

export default ProjectItemSummaryCard;
